// AI Diagnose on Scout diagnostics bundles — mirrors the vortex-api contract
// (DiagnosticReport / ReportBody). Keep the two in step.

export type ReportStatus = 'pending' | 'running' | 'ready' | 'failed';
export type ReportConfidence = 'high' | 'medium' | 'low';

export interface ReportEvidence {
  /** Bundle section, e.g. 'logcat_main'. */
  source: string;
  timestamp: string | null;
  /** Verbatim log line or field. */
  excerpt: string;
  /** Why it matters. */
  note: string;
}

export interface ReportBody {
  headline: string;
  confidence: ReportConfidence;
  skipper_workaround: {
    available: boolean;
    /** Plain text, WhatsApp-ready, no markdown. */
    message: string;
  };
  /** Markdown, a few short paragraphs. */
  diagnosis: string;
  evidence: ReportEvidence[];
  suspected_cause: {
    component: string;
    introduced_in: string | null;
    /** Best-guess paths — a hypothesis, the model has no source. */
    files: string[];
    explanation: string;
  };
  comparison: string | null;
  fleet_impact: {
    same_version_devices: number;
    matching_devices: number;
    recommendation: string;
  } | null;
  bundle_gaps: string[];
}

export interface DiagnosticReport {
  id: string;
  device_id: string;
  bundle_id: string;
  symptom: string | null;
  status: ReportStatus;
  model: string | null;
  error: string | null;
  created_at: string;
  completed_at: string | null;
  requested_by_user_id: string | null;
  cost_cents: number | null;
  report: ReportBody | null;
}

/** The slice of the newest report carried on each bundle row. */
export interface LatestReportSummary {
  id: string;
  status: ReportStatus;
  headline: string | null;
  confidence: ReportConfidence | null;
}

export interface DiagnosticShareLink {
  url: string;
  expires_at: string;
}

/** The longest symptom the API accepts. */
export const SYMPTOM_MAX_LENGTH = 2000;
